export default __webpack_public_path__ + "static/media/Virus.173a55cb.svg";